import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingFallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-slate-900">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 dark:text-orange-500 mx-auto mb-3" />
        <p className="text-sm text-slate-600 dark:text-slate-400">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
